// extracted by mini-css-extract-plugin
export var auto = "_3o-1";
export var spinner = "_3o-0";